<template>
  <div class="d-flex">
    <time-field
      :type="type"
      :label="label"
      :field="field"
      :placeholder="settings.placeholder"
      :help="settings.help_text"
    ></time-field>
    <fb-field-config :field="field"></fb-field-config>
  </div>
</template>

<script>
import { getSettings } from "../../assets/js/common.helper";
import TimeField from "../ui/form/TimeField.vue";
import FbFieldConfig from "./FbFieldConfig.vue";
export default {
  props: { field: {} },
  components: { FbFieldConfig, TimeField },
  computed: {
    label() {
      return this.field.Form_Label;
    },
    type() {
      return this.field.Field_Type;
    },

    settings() {
      return getSettings({ ...this.field });
    },
  },
};
</script>

<style>
</style>